import { useState, useEffect } from 'react';
import { isMobileDevice } from '../utils/pwa';

/**
 * Component to show browser-specific instructions for manually installing the PWA
 */
const InstallInstructions = () => {
  const [browser, setBrowser] = useState('');
  const [isIOS, setIsIOS] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);
  
  useEffect(() => {
    // Detect browser type
    const userAgent = navigator.userAgent;
    
    setIsIOS(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream);
    setIsAndroid(/Android/.test(userAgent));
    
    if (/CriOS/i.test(userAgent)) {
      setBrowser('Chrome iOS');
    } else if (/FxiOS/i.test(userAgent)) {
      setBrowser('Firefox iOS');
    } else if (/EdgiOS/i.test(userAgent)) {
      setBrowser('Edge iOS');
    } else if (/Safari/i.test(userAgent) && isIOS) {
      setBrowser('Safari');
    } else if (/Chrome/i.test(userAgent)) {
      setBrowser('Chrome');
    } else if (/Firefox/i.test(userAgent)) {
      setBrowser('Firefox');
    } else if (/Edge/i.test(userAgent)) {
      setBrowser('Edge');
    } else {
      setBrowser('Other');
    }
  }, [isIOS]);
  
  const toggleInstructions = () => {
    setShowInstructions(!showInstructions);
  };
  
  if (!isMobileDevice() || !showInstructions) {
    return (
      <div className="install-prompt-container">
        <button 
          onClick={toggleInstructions} 
          className="link-button install-instructions-toggle"
        >
          {showInstructions ? 'Hide installation instructions' : 'Show manual installation instructions'}
        </button>
      </div>
    );
  }
  
  return (
    <div className="install-instructions">
      <button 
        onClick={toggleInstructions} 
        className="link-button install-instructions-toggle"
      >
        Hide installation instructions
      </button>
      
      <div className="instructions-content">
        <h3>Install WellFed Cats as an App</h3>
        
        {isIOS && (
          <div className="ios-instructions">
            <p>Since you're using iOS, follow these steps:</p>
            
            {browser === 'Safari' ? (
              <ol>
                <li>Tap the share icon <span className="icon">↑</span> at the bottom of the screen</li>
                <li>Scroll down and tap on "Add to Home Screen"</li>
                <li>Tap "Add" in the top right corner</li>
              </ol>
            ) : (
              <p>For the best installation experience, please open this site in Safari.</p>
            )}
          </div>
        )}
        
        {isAndroid && (
          <div className="android-instructions">
            <p>Since you're using Android, follow these steps:</p>
            
            {browser === 'Chrome' ? (
              <ol>
                <li>Tap the menu icon <span className="icon">⋮</span> in the top right</li>
                <li>Tap "Add to Home screen"</li>
                <li>Tap "Add" when prompted</li>
              </ol>
            ) : (
              <p>For the best installation experience, please open this site in Chrome.</p>
            )}
          </div>
        )}
        
        {!isIOS && !isAndroid && (
          <p>To install this app on your device, look for an "Add to Home Screen" or "Install" option in your browser's menu.</p>
        )}
      </div>
    </div>
  );
};

export default InstallInstructions; 